import * as tslib_1 from "tslib";
import { Global4Service } from '../services/global4.service';
import * as $ from 'jquery';
import * as i0 from "@angular/core";
import * as i1 from "./global4.service";
var FormService = /** @class */ (function () {
    function FormService(global) {
        this.global = global;
        this.Errors = new Array();
    }
    FormService.prototype.CopyDefaults = function (Source) {
        var Returns = new Array();
        for (var Property in Source) {
            Returns[Property] = Source[Property];
        }
        return (Returns);
    };
    FormService.prototype.CopyData = function (Object, Source) {
        for (var Property in Object) {
            Object[Property] = Source[Property];
        }
    };
    FormService.prototype.GetData = function (Object, Data, Exclusions, Times) {
        if (Exclusions === void 0) { Exclusions = []; }
        if (Times === void 0) { Times = []; }
        for (var Property in Object) {
            if (Exclusions.indexOf(Property) === -1) {
                if (Times.indexOf(Property) !== -1) {
                    Object[Property] = this.global.CheckDate('1900-01-01 ' + Data[Property.replace(/_/g, '')].toString());
                }
                else {
                    if (Data[Property.replace(/_/g, '')] !== undefined) {
                        switch (typeof (Object[Property])) {
                            case 'string':
                                //Object[Property] = this.global.decodeHtmlEntity(this.global.IsUndefined(Data[this.global.Replace(Property, '_', '')], '').toString());
                                Object[Property] = this.global.IsUndefined(Data[this.global.Replace(Property, '_', '')], '').toString();
                                break;
                            case 'number':
                                Object[Property] = this.global.IsUndefined(Data[this.global.Replace(Property, '_', '')], 0).toString();
                                break;
                            case 'boolean':
                                Object[Property] = this.global.ToBoolean(this.global.IsUndefined(Data[this.global.Replace(Property, '_', '')], false));
                                break;
                            case 'object':
                                Object[Property] = this.global.CheckDate(Data[Property.replace(/_/g, '')].toString());
                                break;
                        }
                    }
                    else {
                        Object[Property] = null;
                    }
                }
            }
        }
    };
    FormService.prototype.SetParameter = function (Tag, ID, Object, AutoCompletes, DateTimes, TempKey, WithTempKey, ParentModule, ParentKey, TempParentKey) {
        if (AutoCompletes === void 0) { AutoCompletes = []; }
        if (DateTimes === void 0) { DateTimes = []; }
        if (TempKey === void 0) { TempKey = ''; }
        if (WithTempKey === void 0) { WithTempKey = false; }
        if (ParentModule === void 0) { ParentModule = ''; }
        if (ParentKey === void 0) { ParentKey = ''; }
        if (TempParentKey === void 0) { TempParentKey = ''; }
        var AutoCompletesList = new Array();
        for (var Object_1 in AutoCompletes) {
            AutoCompletesList.push(Object_1);
        }
        var Parameter = '<' + Tag + ' ' +
            Tag + 'ID="' + ID + '" ';
        if (ParentModule.trim() !== '') {
            Parameter += ParentModule + 'Key="' + this.global.XMLEncode(ParentKey) + '" ' +
                'Temp' + ParentModule + 'Key="' + this.global.XMLEncode(TempParentKey) + '" ';
        }
        if (WithTempKey === true) {
            Parameter += 'Temp' + Tag + 'Key="' + this.global.XMLEncode(TempKey) + '" ';
        }
        for (var Property in Object) {
            if (this.global.InArray(Property, AutoCompletesList) === true) {
                Parameter += Property + '="' + this.global.XMLEncode(AutoCompletes[Property]) + '" ';
            }
            else if (this.global.InArray(Property, DateTimes) === true) {
                Parameter += Property + '="' + this.global.DateTimeToString(this.global.toISOString(Object[Property])) + '" ';
            }
            else if (Property !== Tag + 'ID') {
                switch (typeof (Object[Property])) {
                    case 'string':
                        Parameter += Property + '="' + this.global.XMLEncode(Object[Property]) + '" ';
                        break;
                    case 'number':
                    case 'boolean':
                        Parameter += Property + '="' + Object[Property].toString() + '" ';
                        break;
                    case 'object':
                        Parameter += Property + '="' + this.global.DateToString(this.global.toISOString(Object[Property])) + '" ';
                        break;
                }
            }
        }
        Parameter += 'UsersKey="' + this.global.XMLEncode(this.global.GetUser('UsersKey')) + '" ';
        Parameter += '/>';
        return (Parameter);
    };
    FormService.prototype.Initialize = function (ParentModule, ModuleName, Label, StoredProcedure, Parameter, Publish) {
        if (Publish === void 0) { Publish = undefined; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.global.Get('Initialize', '', StoredProcedure, Parameter, 'Initializing...', 'A fatal error occurred while trying to execute initialize for ' + Label + '!', 'An unknown error occurred while trying to execute initialize for ' + Label + '!', 'An unknown fatal error occurred while trying to execute initialize for ' + Label + '!', this.global.IsUndefined(Publish, ParentModule.toLowerCase() + ModuleName.toLowerCase() + 'forminitialize'));
                return [2 /*return*/];
            });
        });
    };
    FormService.prototype.Prompt = function (ParentModule, ModuleName, Function, Tag, Label, ID, Message) {
        var _this = this;
        if (Message === void 0) { Message = ''; }
        if (Message.trim() === '') {
            Message = 'Are you sure you want to ' + Function.toLowerCase() + ' the record?';
        }
        this.global.Alert('Prompt', Message, [
            {
                text: 'No',
                role: 'cancel'
            },
            {
                text: 'Yes',
                handler: function () {
                    _this.DeleteRestore(ParentModule, ModuleName, Function, Tag, Label, ID);
                }
            }
        ]);
    };
    FormService.prototype.DeleteRestore = function (ParentModule, ModuleName, Function, Tag, Label, ID) {
        var LoadMessage;
        if (Function === 'Delete') {
            LoadMessage = 'Deleting...';
        }
        else {
            LoadMessage = 'Restoring...';
        }
        var Parameter;
        Parameter = '<' + ModuleName + ' ' +
            ModuleName + 'ID="' + ID + '" ' +
            'UsersKey="' + this.global.XMLEncode(this.global.GetUser('UsersKey')) + '" ' +
            '/>';
        // this.global.Transaction(ModuleName, ModuleName + '_' + Function, Parameter, ParentModule.toLowerCase() + ModuleName.toLowerCase() + 'formdeleterestore', LoadMessage, 'A fatal error occurred while trying to execute ' + Function.toLowerCase() + ' for ' + Label + '!', Label + ' was ' + Function.toLowerCase() + 'd successfully!', 'An unknown error occurred while trying to execute ' + Function.toLowerCase() + ' for ' + Label + '!');
        this.global.Transaction(ModuleName, ModuleName + '_' + Function, Parameter, ParentModule.toLowerCase() + ModuleName.toLowerCase() + 'formresult', LoadMessage, 'A fatal error occurred while trying to execute ' + Function.toLowerCase() + ' for ' + Label + '!', Label + ' was ' + Function.toLowerCase() + 'd successfully!', 'An unknown error occurred while trying to execute ' + Function.toLowerCase() + ' for ' + Label + '!');
    };
    FormService.prototype.Save = function (ParentModule, ModuleName, Function, Tag, Label, StoredProcedure, Parameter, CustomMessages, Publish, ShowResult) {
        if (CustomMessages === void 0) { CustomMessages = []; }
        if (Publish === void 0) { Publish = undefined; }
        if (ShowResult === void 0) { ShowResult = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var LoadMessage, FatalErrorMessage, SuccessMessage, UnknownErrorMessage;
            return tslib_1.__generator(this, function (_a) {
                if (this.global.CountArray(CustomMessages) > 0) {
                    LoadMessage = CustomMessages['LoadMessage'];
                    FatalErrorMessage = CustomMessages['FatalErrorMessage'];
                    SuccessMessage = CustomMessages['SuccessMessage'];
                    UnknownErrorMessage = CustomMessages['UnknownErrorMessage'];
                }
                else {
                    switch (Function) {
                        case 'Add':
                            LoadMessage = 'Adding...';
                            SuccessMessage = Label + ' was added successfully!';
                            FatalErrorMessage = 'A fatal error occurred while trying to execute ' + Function.toLowerCase() + ' for ' + Label + '!';
                            UnknownErrorMessage = 'An unknown error occurred while trying to execute ' + Function.toLowerCase() + ' for ' + Label + '!';
                            break;
                        case 'Save':
                            LoadMessage = 'Saving...';
                            SuccessMessage = Label + ' was saved successfully!';
                            FatalErrorMessage = 'A fatal error occurred while trying to execute ' + Function.toLowerCase() + ' for ' + Label + '!';
                            UnknownErrorMessage = 'An unknown error occurred while trying to execute ' + Function.toLowerCase() + ' for ' + Label + '!';
                            break;
                        case 'Approve':
                            LoadMessage = 'Approving...';
                            SuccessMessage = Label + ' was approved successfully!';
                            FatalErrorMessage = 'A fatal error occurred while trying to execute approving for ' + Label + '!';
                            UnknownErrorMessage = 'An unknown error occurred while trying to execute approving for ' + Label + '!';
                            break;
                        case 'Disapprove':
                            LoadMessage = 'Disapproving...';
                            SuccessMessage = Label + ' was disapproved successfully!';
                            FatalErrorMessage = 'A fatal error occurred while trying to execute disapproving for ' + Label + '!';
                            UnknownErrorMessage = 'An unknown error occurred while trying to execute disapproving for ' + Label + '!';
                            break;
                        case 'Send Back':
                            LoadMessage = 'Sending Back...';
                            SuccessMessage = Label + ' was sent back successfully!';
                            FatalErrorMessage = 'A fatal error occurred while trying to execute send back for ' + Label + '!';
                            UnknownErrorMessage = 'An unknown error occurred while trying to execute send back for ' + Label + '!';
                            break;
                        case 'Cancel':
                            LoadMessage = 'Cancelling...';
                            SuccessMessage = Label + ' request was sent successfully!';
                            FatalErrorMessage = 'A fatal error occurred while trying to send request for ' + Function.toLowerCase() + ' of ' + Label + '!';
                            UnknownErrorMessage = 'An unknown error occurred while trying to send request for ' + Function.toLowerCase() + ' of ' + Label + '!';
                            break;
                        case 'Copy':
                            LoadMessage = 'Copying...';
                            SuccessMessage = Label + ' was copied successfully!';
                            FatalErrorMessage = 'A fatal error occurred while trying to ' + Function.toLowerCase() + ' of ' + Label + '!';
                            UnknownErrorMessage = 'An unknown error occurred while trying to ' + Function.toLowerCase() + ' of ' + Label + '!';
                            break;
                    }
                }
                if (StoredProcedure.trim() === '') {
                    StoredProcedure = ModuleName + '_' + Function;
                }
                if (this.global.IsUndefined(Publish, '') === '') {
                    Publish = ParentModule.toLowerCase() + ModuleName.toLowerCase() + 'formresult';
                }
                this.global.Transaction(ModuleName, StoredProcedure, Parameter, Publish, LoadMessage, FatalErrorMessage, SuccessMessage, UnknownErrorMessage, {}, ShowResult, Tag);
                return [2 /*return*/];
            });
        });
    };
    FormService.prototype.ShowSublistForm = function (ParentModule, ModuleName) {
        $('#' + ParentModule + 'Base').hide();
        $('#' + ParentModule + ModuleName + 'Container').show();
    };
    FormService.prototype.CloseSublistForm = function (ParentModule, ModuleName) {
        $('#' + ParentModule + 'Base').show();
        $('#' + ParentModule + ModuleName + 'Container').hide();
    };
    FormService.prototype.ClearErrors = function (ModuleName) {
        $('#' + ModuleName + 'Container .errorcontainer').each(function () {
            if ($('#' + $(this).attr('id')).hasClass('hidden') === false) {
                $('#' + $(this).attr('id')).addClass('hidden');
            }
        });
    };
    FormService.prototype.ShowError = function (ObjectID) {
        if ($('#' + ObjectID).hasClass('hidden') === true) {
            $('#' + ObjectID).removeClass('hidden');
        }
    };
    FormService.prototype.CheckRequireds = function (ModuleName, entity, Valid) {
        if (Valid === void 0) { Valid = true; }
        for (var node in entity) {
            if ($('#' + ModuleName + node).attr('required') === 'required') {
                switch (typeof (entity[node])) {
                    case 'object':
                        if (this.global.IsUndefined(entity[node], '') === '') {
                            Valid = false;
                            this.ShowError(ModuleName + node + 'Required');
                        }
                        break;
                    case 'number':
                        if (this.global.ParseFloat(entity[node]) <= 0) {
                            Valid = false;
                            this.ShowError(ModuleName + node + 'Required');
                        }
                        break;
                    case 'string':
                        if ($('#' + ModuleName + node).attr('type') === 'password') {
                        }
                        else if ($('#' + ModuleName + node).hasClass('numeric') === true) {
                            if (this.global.ParseFloat(entity[node]) <= 0) {
                                Valid = false;
                                this.ShowError(ModuleName + node + 'Required');
                            }
                        }
                        else if (entity[node].trim() === '') {
                            Valid = false;
                            this.ShowError(ModuleName + node + 'Required');
                        }
                        break;
                }
            }
        }
        return (Valid);
    };
    FormService.ngInjectableDef = i0.defineInjectable({ factory: function FormService_Factory() { return new FormService(i0.inject(i1.Global4Service)); }, token: FormService, providedIn: "root" });
    return FormService;
}());
export { FormService };
